import { Saga } from "redux-saga";
import { Reducer } from "redux";
import createReducer from "reducers";
import { AppStore } from "store";

export default class StoreRegister {
    private static store: AppStore;

    public static setStore(newStore: AppStore) {
        this.store = newStore;
    }

    public static injectAsyncReducer(name: string, asyncReducer: Reducer<any, any>): void {
        this.store.asyncReducers[name] = asyncReducer;
        this.store.replaceReducer(createReducer(this.store.asyncReducers));
    }

    public static runSagaOnStore(name: string, saga: Saga): void {
        if (!this.store.sagas.includes(name)) {
            this.store.sagas.push(name);
            this.store.sagaMiddleware.run(saga);
        }
    }
}
